import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "../Assets/responsive.css";
import "../Assets/slider.css";
import { UserRoundPlus, CircleDollarSign, Mail } from "lucide-react";
import { useVendor } from "../Store/VendorStore";
import { useLocation, useParams } from "react-router-dom";
import "../Assets/VendorProfile.css";
import LoadingSpinner from "../Components/LoadingSpinner";
import Swal from "sweetalert2";
import VendorPayment from "../Components/VendorPayment";
import BookVendorModal from "../Components/BookingVendorModal";
import RateVendorModal from "../Components/RateVendorModal";
import FollowEventsModal from "../Components/FollowEventModal";
import "react-toastify/dist/ReactToastify.css";
import { Modal, ModalBody, FormGroup, Label, Input, Form } from "reactstrap";
import StarRating from "../Components/starRating";
import RatingBreakdown from "../Components/RatingBreakdown";
import NotFound404 from "./NotFound404";

function VendorProfile() {
  const { vendorData, reviewsNewData, tags, fetchVendorDetails, likedEvents } =
    useVendor();

  const safeLikedEvents = Array.isArray(likedEvents)
    ? likedEvents.filter((event) => event && event.Start_Date_Time)
    : [];

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const vendorId = query.get("vendor_profiles_id");
  const userId = query.get("userId");
  const { number } = useParams();
  const [loading, setLoading] = useState(true);
  const { averageRating } = useVendor();
  const [modal, setModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [ratingmodalOpen, ratingsetModalOpen] = useState(false);
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [filteredReviews, setFilteredReviews] = useState([]);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [dateFilter, setDateFilter] = useState("all");

  // New states for tabs
  const [activeTab, setActiveTab] = useState("agenda");
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date());

  // Image carousel states
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isCarousel, setIsCarousel] = useState(false);

  // Animation states
  const [isVisible, setIsVisible] = useState(false);
  const [animationStep, setAnimationStep] = useState(0);

  // Check screen size and set carousel mode
  useEffect(() => {
    const checkScreenSize = () => {
      setIsCarousel(window.innerWidth <= 800);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Animation sequence on component mount
  useEffect(() => {
    setIsVisible(true);
    const animateSequence = async () => {
      await new Promise((resolve) => setTimeout(resolve, 300));
      setAnimationStep(1);
      await new Promise((resolve) => setTimeout(resolve, 200));
      setAnimationStep(2);
      await new Promise((resolve) => setTimeout(resolve, 300));
      setAnimationStep(3);
    };
    animateSequence();
  }, []);

  // Carousel navigation functions
  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === vendorData.Product_Images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? vendorData.Product_Images.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const handleRatingFilter = (rating) => {
    if (selectedRatings.includes(rating)) {
      setSelectedRatings(selectedRatings.filter((r) => r !== rating));
    } else {
      setSelectedRatings([...selectedRatings, rating]);
    }
  };

  const filterReviewsByRatingAndDate = () => {
    let filtered = [...(reviewsNewData || [])];

    if (selectedRatings.length > 0) {
      filtered = filtered.filter((review) =>
        selectedRatings.includes(review.Rating)
      );
    }

    if (dateFilter === "last30Days") {
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      filtered = filtered.filter(
        (review) => new Date(review.created_at) >= thirtyDaysAgo
      );
    } else if (dateFilter === "oldest") {
      filtered.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    } else if (dateFilter === "newest") {
      filtered.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    }

    setFilteredReviews(filtered);
  };

  const clearFilters = () => {
    setSelectedRatings([]);
    setDateFilter(null);
    setFilteredReviews([...reviewsNewData]);
  };
  const handleCopy = () => {
    if (vendorData?.social_profile && vendorData.social_profile.trim() !== "") {
      navigator.clipboard.writeText(vendorData.social_profile).then(() => {
        Swal.fire({
          icon: "success",
          title: "Copied!",
          text: "Link copied to clipboard ✅",
          timer: 2000,
          showConfirmButton: false,
        });
      });
    }
  };
  useEffect(() => {
    filterReviewsByRatingAndDate();
  }, [selectedRatings, dateFilter, reviewsNewData]);

  const ratingtoggleModal = () => ratingsetModalOpen(!ratingmodalOpen);
  const toggleModal = () => setModalOpen(!modalOpen);
  const toggle = () => setModal(!modal);

  const [isOpen, setIsOpen] = useState(false);
  const Followtoggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    const fetchData = async () => {
      await fetchVendorDetails(vendorId, userId);
      setLoading(false);
    };
    fetchData();
  }, []);

  const [visibleCount, setVisibleCount] = useState(5);

  const displayReviews =
    filteredReviews.length > 0 ? filteredReviews : reviewsNewData || [];

  const loadMoreReviews = () => {
    setVisibleCount((prevCount) => prevCount + 5);
  };

  // Calendar helper functions
  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  const getEventsForDate = (date) => {
    if (!date) return [];
    return safeLikedEvents.filter((event) => {
      const eventDate = new Date(event.Start_Date_Time);
      return eventDate.toDateString() === date.toDateString();
    });
  };

  const renderCalendar = () => {
    const daysInMonth = getDaysInMonth(currentMonth);
    const firstDay = getFirstDayOfMonth(currentMonth);
    const days = [];
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
    }

    // Add days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth(),
        day
      );
      const eventsForDay = getEventsForDate(date);
      const hasEvents = eventsForDay.length > 0;

      days.push(
        <div
          key={day}
          className={`calendar-day ${hasEvents ? "has-events" : "disabled"} ${
            selectedDate &&
            selectedDate.getDate() === day &&
            selectedDate.getMonth() === currentMonth.getMonth() &&
            selectedDate.getFullYear() === currentMonth.getFullYear()
              ? "selected"
              : ""
          }`}
          style={{
            cursor: hasEvents ? "pointer" : "not-allowed",
            opacity: hasEvents ? 1 : 0.5,
            backgroundColor:
              selectedDate &&
              selectedDate.getDate() === day &&
              selectedDate.getMonth() === currentMonth.getMonth() &&
              selectedDate.getFullYear() === currentMonth.getFullYear()
                ? "#d6e9fb"
                : hasEvents
                ? "#e8f4fd"
                : "#f8f9fa",
            color: hasEvents ? "#022d88" : "#ccc",
          }}
          onClick={
            hasEvents
              ? () => {
                  // Toggle selection - if same date is clicked, deselect it
                  if (
                    selectedDate &&
                    selectedDate.getDate() === day &&
                    selectedDate.getMonth() === currentMonth.getMonth() &&
                    selectedDate.getFullYear() === currentMonth.getFullYear()
                  ) {
                    setSelectedDate(null);
                  } else {
                    setSelectedDate(date);
                  }
                }
              : undefined
          }
          onMouseEnter={
            hasEvents
              ? (e) => {
                  // Show tooltip with events (existing code)
                  const tooltip = document.createElement("div");
                  tooltip.className = "event-tooltip";
                  tooltip.innerHTML = eventsForDay
                    .map(
                      (event) =>
                        `<div class="tooltip-event">
                  <strong>${event.Event_Name}</strong>
                  <div>${new Date(
                    event.Start_Date_Time
                  ).toLocaleTimeString()}</div>
                  <div>${event.City}, ${event.State}</div>
                </div>`
                    )
                    .join("");
                  tooltip.style.position = "absolute";
                  tooltip.style.background = "#022D88";
                  tooltip.style.color = "white";
                  tooltip.style.padding = "10px";
                  tooltip.style.borderRadius = "5px";
                  tooltip.style.fontSize = "12px";
                  tooltip.style.zIndex = "1000";
                  tooltip.style.maxWidth = "250px";
                  tooltip.style.boxShadow = "0 2px 10px rgba(0,0,0,0.3)";

                  const rect = e.target.getBoundingClientRect();
                  tooltip.style.left = `${rect.left}px`;
                  tooltip.style.top = `${rect.bottom + 5}px`;

                  document.body.appendChild(tooltip);
                  e.target.tooltip = tooltip;
                }
              : undefined
          }
          onMouseLeave={
            hasEvents
              ? (e) => {
                  if (e.target.tooltip) {
                    document.body.removeChild(e.target.tooltip);
                    e.target.tooltip = null;
                  }
                }
              : undefined
          }
        >
          {day}
          {hasEvents && <div className="event-indicator"></div>}
        </div>
      );
    }

    return (
      <div className="calendar-container">
        <div className="calendar-header">
          <button
            className="calendar-nav-btn"
            onClick={() =>
              setCurrentMonth(
                new Date(
                  currentMonth.getFullYear(),
                  currentMonth.getMonth() - 1,
                  1
                )
              )
            }
          >
            <ChevronLeft size={20} />
          </button>
          <h3 className="calendar-month-year">
            {monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}
          </h3>
          <button
            className="calendar-nav-btn"
            onClick={() =>
              setCurrentMonth(
                new Date(
                  currentMonth.getFullYear(),
                  currentMonth.getMonth() + 1,
                  1
                )
              )
            }
          >
            <ChevronRight size={20} />
          </button>
        </div>

        <div className="calendar-weekdays">
          {["S", "M", "T", "W", "T", "F", "S"].map((day) => (
            <div key={day} className="calendar-weekday">
              {day}
            </div>
          ))}
        </div>

        <div className="calendar-grid">{days}</div>
      </div>
    );
  };

  // Image Gallery Styles
  const imageGalleryStyles = {
    container: {
      width: "100%",
      maxWidth: "1024px",
      margin: "0 auto",
      padding: "16px",
    },
    header: {
      textAlign: "center",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "700",
      lineHeight: "27.24px",
      margin: "0",
    },
    // Grid Layout Styles
    gridContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "100%",
      maxWidth: "1100px",
      margin: "0 auto",
      gap: "20px",
      padding: "0 20px",
    },
    mainImageContainer: {
      width: "52%",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
    mainImage: {
      width: "100%",
      height: "520px",
      borderRadius: "20px",
      objectFit: "cover",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      cursor: "pointer",
      border: "3px solid transparent",
    },
    imageCaption: {
      marginTop: "15px",
      padding: "14px 18px",
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      fontSize: "16px",
      fontWeight: "600",
      color: "#022d88",
      textAlign: "center",
      border: "2px solid #e8f0fe",
      boxShadow: "0 4px 12px rgba(2, 45, 136, 0.08)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      lineHeight: "1.5",
      minHeight: "50px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    gridImagesContainer: {
      width: "48%",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "16px",
    },
    gridImageWrapper: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
    gridImage: {
      width: "100%",
      height: "250px",
      borderRadius: "20px",
      objectFit: "cover",
      boxShadow: "0 6px 20px rgba(0, 0, 0, 0.1)",
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      cursor: "pointer",
      border: "3px solid transparent",
    },
    // Carousel Styles
    carouselWrapper: {
      position: "relative",
      width: "100%",
      maxWidth: "672px",
      margin: "0 auto",
    },
    carouselContainer: {
      position: "relative",
      height: "320px",
      overflow: "hidden",
      borderRadius: "16px",
      backgroundColor: "#e5e7eb",
    },
    carouselTrack: {
      display: "flex",
      height: "100%",
      transition: "transform 0.3s ease-in-out",
    },
    carouselSlide: {
      width: "100%",
      height: "100%",
      flexShrink: 0,
      position: "relative",
      display: "flex",
      flexDirection: "column",
    },
    carouselImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "16px",
    },
    carouselCaption: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "rgba(2, 45, 136, 0.9)",
      color: "white",
      padding: "12px 16px",
      fontSize: "14px",
      fontWeight: "600",
      textAlign: "center",
      borderBottomLeftRadius: "16px",
      borderBottomRightRadius: "16px",
    },
    navButton: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "white",
      padding: "8px",
      borderRadius: "50%",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s ease",
      zIndex: 10,
    },
    navButtonLeft: {
      left: "16px",
    },
    navButtonRight: {
      right: "16px",
    },
    counter: {
      position: "absolute",
      top: "16px",
      right: "16px",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "white",
      padding: "4px 12px",
      borderRadius: "20px",
      fontSize: "14px",
    },
    dotsContainer: {
      display: "flex",
      justifyContent: "center",
      marginTop: "16px",
      gap: "8px",
    },
    dot: {
      width: "12px",
      height: "12px",
      borderRadius: "50%",
      border: "none",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    thumbnailContainer: {
      display: "flex",
      justifyContent: "center",
      marginTop: "16px",
      gap: "8px",
      overflowX: "auto",
      paddingBottom: "8px",
    },
    thumbnailButton: {
      flexShrink: 0,
      width: "64px",
      height: "64px",
      borderRadius: "8px",
      overflow: "hidden",
      border: "2px solid",
      cursor: "pointer",
      backgroundColor: "transparent",
      padding: "0",
      transition: "all 0.3s ease",
    },
    thumbnailImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  };

  return (
    <div>
      <style>{`
        /* Enhanced Animations */
        @keyframes slideInFromTop {
          0% {
            transform: translateY(-100px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes slideInFromLeft {
          0% {
            transform: translateX(-100px);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideInFromRight {
          0% {
            transform: translateX(100px);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideInFromBottom {
          0% {
            transform: translateY(100px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes fadeInScale {
          0% {
            transform: scale(0.8);
            opacity: 0;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        @keyframes bounceIn {
          0% {
            transform: scale(0.3);
            opacity: 0;
          }
          50% {
            transform: scale(1.1);
          }
          70% {
            transform: scale(0.9);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes rotateIn {
          0% {
            transform: rotate(-360deg) scale(0);
            opacity: 0;
          }
          100% {
            transform: rotate(0deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes slideInBounce {
          0% {
            transform: translateX(-100%) scale(0.8);
            opacity: 0;
          }
          60% {
            transform: translateX(10%) scale(1.1);
            opacity: 0.8;
          }
          100% {
            transform: translateX(0) scale(1);
            opacity: 1;
          }
        }

        /* Profile Image Animation */
        .image1 {
          animation: ${isVisible ? "fadeInScale 1s ease-out" : "none"};
          transition: all 0.3s ease;
        }

        .image1:hover {
          transform: scale(1.05);
          box-shadow: 0 10px 30px rgba(2, 45, 136, 0.3);
        }

        /* Vendor Name Animation */
        .heading1 {
          animation: ${
            animationStep >= 1 ? "slideInFromTop 0.8s ease-out" : "none"
          };
          transition: all 0.3s ease;
        }

        /* Social Icons Animation */
        .icon,
        .icon1 {
          animation: ${animationStep >= 2 ? "bounceIn 0.6s ease-out" : "none"};
          transition: all 0.3s ease;
        }

        .icon:hover,
        .icon1:hover {
          transform: scale(1.2) rotate(5deg);
          filter: brightness(1.2);
        }

        /* Button Animations */
        .custom-button,
        .custom-outline-button {
          animation: ${
            animationStep >= 3 ? "slideInFromBottom 0.8s ease-out" : "none"
          };
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .custom-button::before,
        .custom-outline-button::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
          );
          transition: left 0.5s;
        }

        .custom-button:hover::before,
        .custom-outline-button:hover::before {
          left: 100%;
        }

        .custom-button:hover,
        .custom-outline-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
        }

        /* Stats Animation */
        .stats-container h3 {
          animation: ${
            animationStep >= 3 ? "slideInFromBottom 1s ease-out" : "none"
          };
          transition: all 0.3s ease;
        }

        .stats-container h3:hover {
          transform: scale(1.1);
          color: #022d88 !important;
        }

        /* About Section Animation */
        .about-heading {
          animation: fadeInScale 1s ease-out;
          transition: all 0.3s ease;
        }

        .about-button {
          animation: slideInFromLeft 0.8s ease-out;
          animation-fill-mode: both;
          transition: all 0.3s ease;
        }

        .about-button:hover {
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }

        .about-button:nth-child(1) {
          animation-delay: 0.1s;
        }
        .about-button:nth-child(2) {
          animation-delay: 0.2s;
        }
        .about-button:nth-child(3) {
          animation-delay: 0.3s;
        }
        .about-button:nth-child(4) {
          animation-delay: 0.4s;
        }

        /* Tab Animation */
        .event-tabs {
          display: flex;
          justify-content: center;
          margin-bottom: 30px;
          border-bottom: 2px solid #e1e1e1;
        }

        .tab-button {
          background: none;
          border: none;
          padding: 15px 30px;
          font-size: 16px;
          font-weight: 600;
          color: #7c93c3;
          cursor: pointer;
          border-bottom: 3px solid transparent;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }

        .tab-button::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 3px;
          background: #022d88;
          transition: all 0.3s ease;
          transform: translateX(-50%);
        }

        .tab-button.active {
          color: #022d88;
          transform: translateY(-2px);
        }

        .tab-button.active::after {
          width: 100%;
        }

        .tab-button:hover {
          color: #022d88;
          transform: translateY(-2px);
        }

        .tab-button:hover::after {
          width: 100%;
        }

        /* Card Animations */
        .card {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          animation: fadeInScale 0.6s ease-out;
          animation-fill-mode: both;
        }

        .card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
        }

        .card:nth-child(1) {
          animation-delay: 0.1s;
        }
        .card:nth-child(2) {
          animation-delay: 0.2s;
        }
        .card:nth-child(3) {
          animation-delay: 0.3s;
        }
        .card:nth-child(4) {
          animation-delay: 0.4s;
        }

        /* Review Card Animation */
        .card-shadow {
          animation: slideInFromRight 0.6s ease-out;
          animation-fill-mode: both;
          transition: all 0.3s ease;
        }

        .card-shadow:hover {
          transform: translateX(5px);
          box-shadow: -5px 5px 20px rgba(0, 0, 0, 0.1);
        }

        .card-shadow:nth-child(odd) {
          animation-name: slideInFromLeft;
        }

        /* Star Rating Animation */
        .reviewstars {
          transition: all 0.2s ease;
        }

        .reviewstars:hover {
          transform: scale(1.2);
          filter: drop-shadow(0 0 5px #022d88);
        }

        /* Calendar Animation */
        .calendar-container {
          max-width: 74vw;
          margin: 0 auto;
          background: white;
          border-radius: 10px;
          padding: 20px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          animation: fadeInScale 0.8s ease-out;
        }

        .calendar-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .calendar-nav-btn {
          background: #022d88;
          color: white;
          border: none;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .calendar-nav-btn:hover {
          background: #0146b7;
          transform: scale(1.1);
        }

        .calendar-month-year {
          font-size: 24px;
          font-weight: bold;
          color: #022d88;
          margin: 0;
          animation: slideInFromTop 0.6s ease-out;
        }

        .calendar-weekdays {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 1px;
          margin-bottom: 10px;
        }

        .calendar-weekday {
          padding: 10px;
          text-align: center;
          font-weight: bold;
          color: #7c93c3;
          background: #f8f9fa;
          animation: slideInFromTop 0.4s ease-out;
          animation-fill-mode: both;
        }

        .calendar-weekday:nth-child(1) {
          animation-delay: 0.1s;
        }
        .calendar-weekday:nth-child(2) {
          animation-delay: 0.15s;
        }
        .calendar-weekday:nth-child(3) {
          animation-delay: 0.2s;
        }
        .calendar-weekday:nth-child(4) {
          animation-delay: 0.25s;
        }
        .calendar-weekday:nth-child(5) {
          animation-delay: 0.3s;
        }
        .calendar-weekday:nth-child(6) {
          animation-delay: 0.35s;
        }
        .calendar-weekday:nth-child(7) {
          animation-delay: 0.4s;
        }

        .calendar-grid {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 1px;
        }

        .calendar-day {
          min-height: 60px;
          padding: 8px;
          border: 1px solid #e1e1e1;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          cursor: pointer;
          position: relative;
          background: white;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          animation: fadeIn 0.5s ease-out;
          animation-fill-mode: both;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .calendar-day:hover {
          background: #f8f9fa;
          transform: scale(1.05);
        }

        .calendar-day.empty {
          background: #f5f5f5;
          cursor: default;
        }

        .calendar-day.has-events {
          background: #e8f4fd;
          border-color: #022d88;
          animation: pulse 2s infinite;
        }

        .calendar-day.has-events:hover {
          background: #d6e9fb;
          transform: scale(1.1);
        }

        .event-indicator {
          width: 8px;
          height: 8px;
          background: #022d88;
          border-radius: 50%;
          position: absolute;
          top: 5px;
          right: 5px;
          animation: pulse 1.5s infinite;
        }

        .tooltip-event {
          margin-bottom: 8px;
        }

        .tooltip-event:last-child {
          margin-bottom: 0;
        }

        /* Image Gallery Animations */
        .image-gallery {
          animation: fadeInScale 1s ease-out;
        }

        /* Image Caption Hover Effect - Desktop Only */
        @media (min-width: 801px) {
          .product-image-wrapper {
            transition: transform 0.3s ease;
          }

          .product-image-wrapper:hover {
            transform: translateY(-5px);
          }

          .product-image-wrapper img {
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .product-image-wrapper:hover img {
            transform: scale(1.02);
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
            border-color: #022d88;
          }

          .product-image-caption {
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            word-wrap: break-word;
            overflow-wrap: break-word;
          }

          .product-image-wrapper:hover .product-image-caption {
            background: linear-gradient(135deg, #022d88 0%, #0146b7 100%) !important;
            color: white !important;
            transform: translateY(-3px);
            box-shadow: 0 6px 20px rgba(2, 45, 136, 0.25);
            border-color: #022d88;
          }

          /* Improve grid layout for better spacing */
          .product-image-wrapper:nth-child(odd) {
            animation-delay: 0.1s;
          }

          .product-image-wrapper:nth-child(even) {
            animation-delay: 0.2s;
          }
        }

        /* Carousel Navigation Button Hover */
        .carousel-nav-btn:hover {
          transform: translateY(-50%) scale(1.2);
          background-color: rgba(0, 0, 0, 0.8);
        }

        /* Dot Hover Animation */
        .carousel-dot:hover {
          transform: scale(1.3);
        }

        /* Thumbnail Hover */
        .carousel-thumbnail:hover {
          transform: scale(1.1);
          border-color: #2563eb !important;
        }

        /* Enhanced Scrolling Header */
        .scroll-container {
          background: linear-gradient(45deg, #0d1345, #0d1345, #7c93c3);
          background-size: 300% 300%;
          animation: gradientShift 4s ease infinite;
          overflow: hidden;
          white-space: nowrap;
          padding: 15px 0;
          position: relative;
        }

        @keyframes gradientShift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }

        .scroll-track {
          display: flex;
          width: max-content;
          animation: marquee 60s linear infinite;
          will-change: transform;
        }

        @keyframes marquee {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }

        .scroll-track span {
          margin: 0 50px;
          display: inline-block;
          transition: all 0.3s ease;
          font-size: 24px;
          font-weight: 700;
        }

        .scroll-track span:hover {
          transform: scale(1.2);
          color: #ffd700;
        }

        /* Box Border Animation */
        .boxborder {
          animation: slideInFromBottom 0.8s ease-out;
          animation-fill-mode: both;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .boxborder::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #022d88, transparent);
          transition: left 0.5s ease;
        }

        .boxborder:hover::before {
          left: 100%;
        }

        .boxborder:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(2, 45, 136, 0.1);
        }

        .boxborder:nth-child(1) {
          animation-delay: 0.1s;
        }
        .boxborder:nth-child(2) {
          animation-delay: 0.3s;
        }
        .boxborder:nth-child(3) {
          animation-delay: 0.5s;
        }

        /* Load More Button Animation */
        .load-more-btn {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }

        .load-more-btn::after {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(0, 123, 255, 0.3),
            transparent
          );
          transition: left 0.5s;
        }

        .load-more-btn:hover::after {
          left: 100%;
        }

        .load-more-btn:hover {
          transform: scale(1.05);
          text-shadow: 0 0 10px rgba(0, 123, 255, 0.5);
        }

        /* Filter Icon Animation */
        .reviewicon2 {
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .reviewicon2:hover {
          transform: rotate(15deg) scale(1.2);
          color: #022d88 !important;
          filter: drop-shadow(0 0 5px #022d88);
        }

        /* Modal Animation */
        .modal {
          animation: modalFadeIn 0.3s ease-out;
        }

        @keyframes modalFadeIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        /* Heart Icon Animation */
        .icon2 {
          transition: all 0.3s ease;
        }

        .icon2:hover {
          transform: scale(1.3);
          filter: hue-rotate(20deg) brightness(1.2);
        }

        /* Responsive Animations */
        @media (max-width: 768px) {
          .tab-button {
            padding: 12px 20px;
            font-size: 14px;
          }

          .calendar-day {
            min-height: 40px;
            font-size: 12px;
          }

          .calendar-month-year {
            font-size: 18px;
          }

          .custom-button,
          .custom-outline-button {
            transform: scale(0.9);
          }

          .custom-button:hover,
          .custom-outline-button:hover {
            transform: scale(0.95) translateY(-2px);
          }
        }

        /* Sticky App Store Footer Styles */
        .sticky-app-footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background-color: #0D1345;
          padding: 15px 20px;
          box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
          z-index: 1000;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .sticky-app-footer img {
          height: 50px;
          width: auto;
          transition: transform 0.3s ease;
        }

        .sticky-app-footer img:hover {
          transform: scale(1.05);
        }

        @media (max-width: 768px) {
          .sticky-app-footer {
            padding: 12px 15px;
            gap: 12px;
          }

          .sticky-app-footer img {
            height: 40px;
          }

          .sticky-app-footer > div:first-child {
            font-size: 14px;
            margin-right: 5px;
          }
        }

        @media (max-width: 480px) {
          .sticky-app-footer {
            padding: 10px 12px;
            gap: 8px;
          }

          .sticky-app-footer img {
            height: 35px;
          }

          .sticky-app-footer > div:first-child {
            font-size: 12px;
            margin-right: 0;
            width: 100%;
            text-align: center;
            margin-bottom: 5px;
          }
        }

        /* Loading State Animation */
        .loading-spinner {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        /* Intersection Observer Animations */
        .fade-in-observer {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.6s ease;
        }

        .fade-in-observer.visible {
          opacity: 1;
          transform: translateY(0);
        }

        /* Statistics Counter Animation */
        .stats-counter {
          animation: countUp 1.5s ease-out;
        }

        @keyframes countUp {
          from {
            opacity: 0;
            transform: scale(0.5);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        /* Staggered Animation for Review Stars */
        .rating-stars .reviewstars {
          animation: starAppear 0.3s ease-out;
          animation-fill-mode: both;
        }

        .rating-stars .reviewstars:nth-child(1) {
          animation-delay: 0.1s;
        }
        .rating-stars .reviewstars:nth-child(2) {
          animation-delay: 0.2s;
        }
        .rating-stars .reviewstars:nth-child(3) {
          animation-delay: 0.3s;
        }
        .rating-stars .reviewstars:nth-child(4) {
          animation-delay: 0.4s;
        }
        .rating-stars .reviewstars:nth-child(5) {
          animation-delay: 0.5s;
        }

        @keyframes starAppear {
          0% {
            opacity: 0;
            transform: scale(0) rotate(-180deg);
          }
          100% {
            opacity: 1;
            transform: scale(1) rotate(0deg);
          }
        }

        /* Smooth Page Transitions */
        .page-transition {
          animation: pageSlideIn 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }

        @keyframes pageSlideIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <div>
        {loading ? (
          <LoadingSpinner />
        ) : vendorData ? (
          // Rest of your JSX when loading is false
          <div style={{ paddingBottom: "100px" }}>
            <div className="scroll-container">
              <div className="scroll-track">
                {Array.from({ length: 30 }).map((_, index) => (
                  <span key={`s1-${index}`}>{vendorData.Name}</span>
                ))}
                {Array.from({ length: 30 }).map((_, index) => (
                  <span key={`s2-${index}`}>{vendorData.Name}</span>
                ))}
              </div>
            </div>

            <Container
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {/* TopSection*/}

              <Container
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                <div className="boxborder">
                  <Row
                    style={{
                      width: "100%",
                      margin: "10px 6px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      style={{ display: "flex", justifyContent: "center" }}
                      className="me-md-3"
                    >
                      {vendorData?.booth_bonus_active ? (
                        <div
                          style={{
                            position: "relative",
                            width: "clamp(200px, 60vw, 320px)",
                            height: "clamp(200px, 60vw, 320px)",
                            display: "inline-block",
                          }}
                        >
                          <img
                            className="image1"
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "2000px",
                              border: "clamp(12px, 5vw, 25px) solid #B9D9CE",
                              objectFit: "cover",
                            }}
                            src={
                              vendorData?.Profile_Image?.url ||
                              "https://www.shutterstock.com/image-vector/vector-flat-illustration-grayscale-avatar-600nw-2264922221.jpg"
                            }
                            alt="Vendor Profile"
                          />
                          <svg
                            viewBox="0 0 314 314"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              pointerEvents: "none",
                            }}
                          >
                            <defs>
                              <path
                                id="bonusCirclePath"
                                d="M157,157 m -145,0 a 145,145 0 1,1 290,0 a 145,145 0 1,1 -290,0"
                              />
                            </defs>
                            <text
                              fontSize="18"
                              fontWeight="800"
                              fill="#0D1345"
                              letterSpacing="2"
                            >
                              <textPath
                                xlinkHref="#bonusCirclePath"
                                startOffset="50%"
                                textAnchor="middle"
                              >
                                BOOTH BONUS VENDOR
                              </textPath>
                            </text>
                          </svg>
                        </div>
                      ) : (
                        <img
                          className="image1"
                          style={{
                            width: "280px",
                            height: "280px",
                            borderRadius: "2000px",
                          }}
                          src={
                            vendorData?.Profile_Image?.url ||
                            "https://www.shutterstock.com/image-vector/vector-flat-illustration-grayscale-avatar-600nw-2264922221.jpg"
                          }
                          alt="Vendor Profile"
                        />
                      )}
                    </Col>
                    <Col
                      xs={12}
                      md={5}
                      lg={5}
                      style={{ paddingTop: "15px", justifyContent: "center" }}
                    >
                      <Row
                        style={{
                          paddingTop: "5px",
                          justifyContent: "center",
                          alignContent: "center",
                          justifyItems: "center",
                          alignItems: "center",
                        }}
                      >
                        <Col xs={12} md={12} lg={12} className="text-center">
                          <h1
                            className="heading1"
                            style={{ fontWeight: "700" }}
                          >
                            {vendorData.Name || "Vendor Name"}
                          </h1>
                          <span>{vendorData.City}</span>,
                          <span className="mx-1">{vendorData.State}</span>
                        </Col>
                      </Row>

                      <Row
                        className="justify-content-center align-items-center"
                        style={{
                          paddingTop: "15px",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        {vendorData?.facebook_profile &&
                          vendorData.facebook_profile.trim() !== "" && (
                            <Col
                              xs={2}
                              md={2}
                              className="text-center"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <a
                                href={vendorData.facebook_profile}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  className="icon"
                                  src="/images/Icon awesome-facebook-f.png"
                                  alt="Facebook"
                                />
                              </a>
                            </Col>
                          )}

                        {vendorData?.instagram_profile &&
                          vendorData.instagram_profile.trim() !== "" && (
                            <Col
                              xs={2}
                              md={2}
                              className="text-center"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <a
                                href={vendorData.instagram_profile}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  className="icon"
                                  src="/images/Icon awesome-instagram.png"
                                  alt="Instagram"
                                />
                              </a>
                            </Col>
                          )}

                        {vendorData?.tiktok_profile &&
                          vendorData.tiktok_profile.trim() !== "" && (
                            <Col
                              xs={2}
                              md={2}
                              className="text-center"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <a href={vendorData.tiktok_profile}>
                                <img
                                  className="icon"
                                  src="/images/Icon simple-tiktok.png"
                                  alt="TikTok"
                                />
                              </a>
                            </Col>
                          )}
                        {vendorData?.youtube_profile &&
                          vendorData.youtube_profile.trim() !== "" && (
                            <Col
                              xs={2}
                              md={2}
                              className="text-center"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <a
                                href={vendorData.youtube_profile}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  className="icon"
                                  src="/images/youtube.png"
                                  alt="Instagram"
                                />
                              </a>
                            </Col>
                          )}
                        {vendorData?.other_profile &&
                          vendorData.other_profile.trim() !== "" && (
                            <Col
                              xs={2}
                              md={2}
                              className="text-center"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <a
                                href={vendorData.other_profile}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  className="icon"
                                  src="/images/Icon awesome-social.png"
                                  alt="social"
                                />
                              </a>
                            </Col>
                          )}
                        {/* Clipboard Copy */}
                        {vendorData?.social_profile &&
                          vendorData.social_profile.trim() !== "" && (
                            <Col xs={2} md={2} className="text-center">
                              <button
                                onClick={handleCopy}
                                style={{
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                  padding: 0,
                                }}
                              >
                                <img
                                  className="icon"
                                  src="/images/clipboard.png"
                                  alt="social"
                                />
                              </button>
                            </Col>
                          )}
                      </Row>

                      <Row
                        style={{
                          paddingTop: "25px",
                          width: "100%",
                          marginLeft: "0.1rem",
                        }}
                      >
                        <Col xs={12} md={12} className="text-center m-0 p-0">
                          <Button
                            variant="primary"
                            size="lg"
                            onClick={Followtoggle}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingRight: "24%",
                              justifyContent: "space-between",
                            }}
                            className="custom-button"
                          >
                            <UserRoundPlus
                              size={18}
                              style={{ marginRight: "8px", marginTop: "-2%" }}
                            />
                            FOLLOW MY EVENTS
                          </Button>
                          <FollowEventsModal
                            isOpen={isOpen}
                            toggle={Followtoggle}
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{
                          paddingTop: "7px",
                          width: "100%",
                          marginLeft: "0.1rem",
                        }}
                      >
                        <Col xs={6} md={6} className="text-center m-0 p-0">
                          <Button
                            variant="outline-light"
                            size="lg"
                            onClick={toggleModal}
                            className="custom-outline-button followmyeventButton "
                            style={{
                              padding: "5% 10%",
                              backgroundColor: "#BFBFDB",
                              display: "flex",
                              alignItems: "center",
                              paddingRight: "22%",
                              justifyContent: "space-between",
                              width: "98% !important",
                            }}
                          >
                            <Mail
                              size={18}
                              style={{ marginRight: "8px", marginTop: "-2%" }}
                            />
                            BOOK ME
                          </Button>
                          <BookVendorModal
                            isOpen={modalOpen}
                            toggle={toggleModal}
                          />
                        </Col>
                        <Col xs={6} md={6} className="text-center m-0 p-0">
                          <div>
                            <Button
                              variant="outline-light"
                              size="lg"
                              className="custom-outline-button"
                              onClick={toggle}
                              style={{
                                padding: "5% 30% 5% 10% ",
                                backgroundColor: "#BFBFDB",
                                display: "flex",
                                alignItems: "center",
                                paddingRight: "22%",
                                justifyContent: "space-between",
                              }}
                            >
                              <CircleDollarSign
                                size={18}
                                style={{
                                  marginRight: "8px",
                                  marginTop: "-2%",
                                }}
                              />
                              PAY ME
                            </Button>

                            <VendorPayment isOpen={modal} toggle={toggle} />
                          </div>
                        </Col>
                      </Row>

                      <div className="stats">
                        <div className="stat">
                          <div className="stat-label">YEARS</div>
                          <div className="stat-value">{vendorData.Years}</div>
                        </div>
                        <div className="stat-sep"></div>
                        <div className="stat">
                          <div className="stat-label">RATING</div>
                          <div className="stat-value">
                            {averageRating}{" "}
                            <span
                              style={{ color: "#F9C900", fontSize: "1.44rem" }}
                            >
                              ★
                            </span>
                          </div>
                        </div>
                        <div className="stat-sep"></div>
                        <div className="stat">
                          <div className="stat-label">EVENTS</div>
                          <div className="stat-value">{vendorData.events}</div>
                        </div>
                        <div className="stat-sep"></div>
                        <div className="stat">
                          <div className="stat-label">FANS</div>
                          <div className="stat-value">{vendorData.fans}</div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="boxborder">
                  <Row>
                    <Col className="text-center">
                      <h1 className="about-heading about-text mb-2">
                        ABOUT ME
                      </h1>
                    </Col>
                  </Row>

                  <Row className="button-row  mb-1 justify-content-center">
                    {tags.map((label, index) => (
                      <Col xs="auto" key={index} className="text-center p-2">
                        <Button className="about-button">{label}</Button>
                      </Col>
                    ))}
                  </Row>

                  <Row className="justify-content-center">
                    <Col
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="text-center about-description-container"
                    >
                      <h4 className="about-description">{vendorData.About}</h4>
                    </Col>
                  </Row>
                </div>
                <div className="boxborder">
                  <div style={imageGalleryStyles.header}>
                    <h1
                      className="about-heading mb-4 liked-events"
                      style={{
                        fontWeight: "700",
                      }}
                    >
                      MY PHOTOS ({vendorData.Product_Images?.length || 0})
                    </h1>
                  </div>

                  {vendorData.Product_Images &&
                    vendorData.Product_Images.length > 0 && (
                      <>
                        {/* Desktop Grid Layout (>800px) */}
                        {!isCarousel && (
                          <div style={imageGalleryStyles.gridContainer}>
                            {/* Left Side - Main Image */}
                            <div style={imageGalleryStyles.mainImageContainer} className="product-image-wrapper">
                              <img
                                style={imageGalleryStyles.mainImage}
                                src={vendorData.Product_Images[0].image.url}
                                alt="Main Product"
                              />
                              {vendorData.Product_Images[0].image_text && (
                                <div style={imageGalleryStyles.imageCaption} className="product-image-caption">
                                  {vendorData.Product_Images[0].image_text}
                                </div>
                              )}
                            </div>

                            {/* Right Side - Additional Images */}
                            <div style={imageGalleryStyles.gridImagesContainer}>
                              {vendorData.Product_Images.slice(1, 5).map(
                                (product, index) => (
                                  <div
                                    key={product.id}
                                    style={imageGalleryStyles.gridImageWrapper}
                                    className="product-image-wrapper"
                                  >
                                    <img
                                      style={imageGalleryStyles.gridImage}
                                      src={product.image.url}
                                      alt={`Product ${index + 2}`}
                                    />
                                    {product.image_text && (
                                      <div style={imageGalleryStyles.imageCaption} className="product-image-caption">
                                        {product.image_text}
                                      </div>
                                    )}
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}

                        {/* Mobile Carousel Layout (≤800px) */}
                        {isCarousel && (
                          <div style={imageGalleryStyles.carouselWrapper}>
                            {/* Carousel Container */}
                            <div style={imageGalleryStyles.carouselContainer}>
                              <div
                                style={{
                                  ...imageGalleryStyles.carouselTrack,
                                  transform: `translateX(-${
                                    currentIndex * 100
                                  }%)`,
                                }}
                              >
                                {vendorData.Product_Images.map(
                                  (product, index) => (
                                    <div
                                      key={product.id}
                                      style={imageGalleryStyles.carouselSlide}
                                    >
                                      <img
                                        style={imageGalleryStyles.carouselImage}
                                        src={product.image.url}
                                        alt={`Product ${index + 1}`}
                                      />
                                      {product.image_text && (
                                        <div style={imageGalleryStyles.carouselCaption}>
                                          {product.image_text}
                                        </div>
                                      )}
                                    </div>
                                  )
                                )}
                              </div>

                              {/* Navigation Arrows */}
                              <button
                                onClick={prevSlide}
                                style={{
                                  ...imageGalleryStyles.navButton,
                                  ...imageGalleryStyles.navButtonLeft,
                                }}
                                aria-label="Previous image"
                              >
                                <ChevronLeft size={24} />
                              </button>

                              <button
                                onClick={nextSlide}
                                style={{
                                  ...imageGalleryStyles.navButton,
                                  ...imageGalleryStyles.navButtonRight,
                                }}
                                aria-label="Next image"
                              >
                                <ChevronRight size={24} />
                              </button>

                              {/* Image Counter */}
                              <div style={imageGalleryStyles.counter}>
                                {currentIndex + 1} /{" "}
                                {vendorData.Product_Images.length}
                              </div>
                            </div>

                            {/* Dots Indicator */}
                            <div style={imageGalleryStyles.dotsContainer}>
                              {vendorData.Product_Images.map((_, index) => (
                                <button
                                  key={index}
                                  onClick={() => goToSlide(index)}
                                  style={{
                                    ...imageGalleryStyles.dot,
                                    backgroundColor:
                                      index === currentIndex
                                        ? "#2563eb"
                                        : "#d1d5db",
                                  }}
                                  aria-label={`Go to image ${index + 1}`}
                                />
                              ))}
                            </div>

                            {/* Thumbnail Strip */}
                            <div style={imageGalleryStyles.thumbnailContainer}>
                              {vendorData.Product_Images.map(
                                (product, index) => (
                                  <button
                                    key={product.id}
                                    onClick={() => goToSlide(index)}
                                    style={{
                                      ...imageGalleryStyles.thumbnailButton,
                                      borderColor:
                                        index === currentIndex
                                          ? "#2563eb"
                                          : "#d1d5db",
                                    }}
                                  >
                                    <img
                                      style={imageGalleryStyles.thumbnailImage}
                                      src={product.image.url}
                                      alt={`Thumbnail ${index + 1}`}
                                    />
                                  </button>
                                )
                              )}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                </div>
              </Container>

              {/* Cards - Modified with Tabs */}
              <Container>
                <div className="boxborder">
                  <div
                    style={{ textAlign: "center" }}
                    className="card-containers"
                  >
                    <h1
                      className="about-heading liked-events"
                      style={{
                        fontWeight: "700",
                      }}
                    >
                      MY LIKED EVENTS
                    </h1>

                    {/* Tabs Navigation */}
                    <div className="event-tabs">
                      <button
                        className={`tab-button ${
                          activeTab === "agenda" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("agenda")}
                      >
                        Agenda View
                      </button>
                      <button
                        className={`tab-button ${
                          activeTab === "calendar" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("calendar")}
                      >
                        Calendar View
                      </button>
                    </div>
                  </div>

                  {/* Tab Content */}
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    {activeTab === "agenda" && (
                      <div className="agenda-view">
                        {safeLikedEvents.length > 0 ? (
                          safeLikedEvents.map((event, index) => {
                            const d = new Date(event.Start_Date_Time);
                            const weekday = d
                              .toLocaleDateString("en-US", { weekday: "short" })
                              .toUpperCase();
                            const monthDay = d.toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                            });
                            const timeStr = d.toLocaleTimeString("en-US", {
                              hour: "numeric",
                              minute: "2-digit",
                            });
                            return (
                              <a
                                key={index}
                                href={event.Event_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none" }}
                              >
                                <div className="agenda-card">
                                  <img
                                    className="agenda-image"
                                    src={event.Event_Image_URL}
                                    alt={event.Event_Name}
                                  />
                                  <div className="agenda-content">
                                    <div className="date-badge">
                                      <span className="weekday">{weekday}</span>
                                      <div className="date-detail">
                                        {monthDay}
                                        <br />
                                        {timeStr}
                                      </div>
                                    </div>

                                    <h3 className="agenda-title">
                                      {event.Event_Name}
                                    </h3>
                                    <div className="agenda-location">
                                      {event.City}, {event.State}
                                    </div>

                                    <div className="agenda-footer">
                                      {event.Event_Provider ===
                                        "Eventbrite" && (
                                        <>
                                          <img
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                            }}
                                            src="/images/eicon.png"
                                            alt="Eventbrite"
                                          />
                                        </>
                                      )}
                                      <img
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                        }}
                                        src="/images/fbicon.png"
                                        alt="Facebook"
                                      />
                                      {/* <i className="bi bi-three-dots agenda-icon"></i> */}
                                    </div>
                                  </div>
                                </div>
                              </a>
                            );
                          })
                        ) : (
                          <p
                            style={{
                              textAlign: "center",
                              color: "#7C93C3",
                              fontSize: "18px",
                            }}
                          >
                            No liked events available.
                          </p>
                        )}
                      </div>
                    )}

                    {activeTab === "calendar" && (
                      <div className="calendar-view">
                        {renderCalendar()}

                        {/* Event Cards Section - Shows when a date is selected */}
                        {selectedDate &&
                          getEventsForDate(selectedDate).length > 0 && (
                            <div
                              className="selected-date-events"
                              style={{
                                marginTop: "30px",
                                padding: "20px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "15px",
                                border: "2px solid #022d88",
                              }}
                            >
                              <div
                                style={{
                                  textAlign: "center",
                                  marginBottom: "20px",
                                }}
                              >
                                <h3
                                  style={{
                                    color: "#022d88",
                                    fontWeight: "bold",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Events on{" "}
                                  {selectedDate.toLocaleDateString("en-US", {
                                    weekday: "long",
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })}
                                </h3>
                                <div
                                  style={{
                                    width: "60px",
                                    height: "3px",
                                    backgroundColor: "#022D88",
                                    margin: "0 auto",
                                  }}
                                ></div>
                              </div>

                              <div
                                className="date-events-grid"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "20px",
                                  maxWidth: "100%",
                                }}
                              >
                                {getEventsForDate(selectedDate).map(
                                  (event, index) => (
                                    <a
                                      key={index}
                                      href={event.Event_URL}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ textDecoration: "none" }}
                                    >
                                      <div className="agenda-card">
                                        <img
                                          className="agenda-image"
                                          src={event.Event_Image_URL}
                                          alt={event.Event_Name}
                                        />
                                        <div className="agenda-content">
                                          <div className="date-badge">
                                            <span className="weekday">
                                              {new Date(event.Start_Date_Time)
                                                .toLocaleDateString("en-US", {
                                                  weekday: "short",
                                                })
                                                .toUpperCase()}
                                            </span>
                                            <div className="date-detail">
                                              {new Date(
                                                event.Start_Date_Time
                                              ).toLocaleDateString("en-US", {
                                                month: "short",
                                                day: "numeric",
                                              })}
                                              <br />
                                              {new Date(
                                                event.Start_Date_Time
                                              ).toLocaleTimeString("en-US", {
                                                hour: "numeric",
                                                minute: "2-digit",
                                              })}
                                            </div>
                                          </div>

                                          <h3 className="agenda-title">
                                            {event.Event_Name}
                                          </h3>
                                          <div className="agenda-location">
                                            {event.City}, {event.State}
                                          </div>

                                          <div className="agenda-footer">
                                            {event.Event_Provider ===
                                              "Eventbrite" && (
                                              <>
                                                <img
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  src="/images/eicon.png"
                                                  alt="Eventbrite"
                                                />
                                              </>
                                            )}
                                            <img
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                              }}
                                              src="/images/fbicon.png"
                                              alt="Heart"
                                            />
                                            {/* <i className="bi bi-three-dots agenda-icon"></i> */}
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  )
                                )}
                              </div>

                              {/* Close button */}
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "25px",
                                }}
                              >
                                <button
                                  onClick={() => setSelectedDate(null)}
                                  style={{
                                    backgroundColor: "#022d88",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "25px",
                                    padding: "12px 30px",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",
                                    boxShadow:
                                      "0 4px 12px rgba(2, 45, 136, 0.3)",
                                  }}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor = "#0146b7";
                                    e.target.style.transform =
                                      "translateY(-2px)";
                                    e.target.style.boxShadow =
                                      "0 6px 20px rgba(2, 45, 136, 0.4)";
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor = "#022d88";
                                    e.target.style.transform = "translateY(0)";
                                    e.target.style.boxShadow =
                                      "0 4px 12px rgba(2, 45, 136, 0.3)";
                                  }}
                                >
                                  Close Events
                                </button>
                              </div>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </Container>

              {/* Ratings & Reviews Section */}
              <Container>
                <div className="boxborder">
                  <Row className=" mb-3 rating-container">
                    <Col className="text-center">
                      <h1
                        className="about-heading"
                        style={{ fontWeight: "bold" }}
                      >
                        RATINGS & REVIEWS
                      </h1>
                    </Col>
                  </Row>

                  <StarRating />

                  <Row className="mb-4 mt-4 justify-content-center">
                    <Col xs={12} md={8} lg={6} className="text-center">
                      <Button
                        variant="primary"
                        onClick={ratingtoggleModal}
                        style={{
                          color: "black",
                          width: "60%",
                          height: "44px",
                          backgroundColor: "#B9D9CE",
                          fontWeight: "bold",
                          fontSize: "15px",
                          borderColor: "black",
                        }}
                      >
                        WRITE A REVIEW
                      </Button>
                      <RateVendorModal
                        isOpen={ratingmodalOpen}
                        toggle={ratingtoggleModal}
                      />
                    </Col>
                  </Row>

                  <RatingBreakdown />

                  <Row
                    style={{ marginTop: "4rem", marginBottom: "2rem" }}
                    className="recent-review-container"
                  >
                    <Col>
                      <div className="d-flex justify-content-between align-items-center">
                        <h3
                          style={{ color: "#0D1345" }}
                          className="mx-md-4 reviewheading"
                        >
                          MOST RECENT REVIEWS
                        </h3>
                        <div
                          className="d-flex align-items-center "
                          style={{ marginRight: "20px" }}
                        >
                          <i
                            className="bi bi-funnel-fill reviewicon2"
                            style={{ color: "#0D1345", fontSize: "1.6rem" }}
                            onClick={() => setFilterModalOpen(true)}
                          ></i>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Modal
                    isOpen={filterModalOpen}
                    toggle={() => setFilterModalOpen(!filterModalOpen)}
                    backdrop="static"
                  >
                    <div className="d-flex justify-content-between align-items-center  ">
                      <h3
                        style={{
                          color: "GrayText",
                          padding: "25px 45px 0px 45px ",
                          fontWeight: "400",
                          fontSize: "22px",
                        }}
                      >
                        REVIEW FILTERS
                      </h3>
                    </div>
                    <ModalBody style={{ padding: "25px 45px 45px 45px " }}>
                      <Form>
                        <FormGroup>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Label
                              className="Filter-Font"
                              for="ratingFilter"
                              style={{
                                fontWeight: "400",
                                color: "GrayText",
                                fontSize: "22px",
                              }}
                            >
                              Filter by Rating
                            </Label>
                            <Label
                              className="Filter-Font"
                              for="ratingFilter"
                              style={{
                                fontWeight: "400",
                                color: "blue",
                                fontSize: "18px",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                              onClick={() => {
                                clearFilters();
                                setFilterModalOpen(false);
                              }}
                            >
                              Clear Filters
                            </Label>
                          </div>
                          <div className="d-flex flex-column">
                            {[5, 4, 3, 2, 1].map((rating) => (
                              <div
                                key={rating}
                                className="d-flex align-items-center"
                              >
                                <Input
                                  type="checkbox"
                                  id={`rating-${rating}`}
                                  className="me-2"
                                  checked={selectedRatings.includes(rating)}
                                  onChange={() => handleRatingFilter(rating)}
                                />
                                <div>
                                  {[...Array(5)].map((_, i) => (
                                    <span
                                      key={i}
                                      style={{
                                        color:
                                          i < rating ? "#FECD00" : "#e4e5e9",
                                        fontSize: "2.5rem",
                                      }}
                                    >
                                      ★
                                    </span>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        </FormGroup>

                        <FormGroup>
                          <Label
                            for="datePosted"
                            style={{
                              fontWeight: "400",
                              color: "GrayText",
                              fontSize: "22px",
                            }}
                          >
                            Date Posted
                          </Label>
                          <div className="d-flex flex-column">
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="datePosted"
                                  value="all"
                                  checked={dateFilter === "all"}
                                  onChange={(e) =>
                                    setDateFilter(e.target.value)
                                  }
                                />{" "}
                                <span
                                  style={{
                                    fontWeight: "200",
                                    color: "GrayText",
                                    marginLeft: "29px",
                                    fontSize: "20px",
                                  }}
                                >
                                  All Reviews
                                </span>
                              </Label>
                            </FormGroup>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="datePosted"
                                  value="last30Days"
                                  checked={dateFilter === "last30Days"}
                                  onChange={(e) =>
                                    setDateFilter(e.target.value)
                                  }
                                />{" "}
                                <span
                                  style={{
                                    fontWeight: "200",
                                    color: "GrayText",
                                    marginLeft: "29px",
                                    fontSize: "20px",
                                  }}
                                >
                                  Last 30 Days
                                </span>
                              </Label>
                            </FormGroup>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="datePosted"
                                  value="oldest"
                                  checked={dateFilter === "oldest"}
                                  onChange={(e) =>
                                    setDateFilter(e.target.value)
                                  }
                                />{" "}
                                <span
                                  style={{
                                    fontWeight: "200",
                                    color: "GrayText",
                                    marginLeft: "29px",
                                    fontSize: "20px",
                                  }}
                                >
                                  Oldest First
                                </span>
                              </Label>
                            </FormGroup>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="datePosted"
                                  value="newest"
                                  checked={dateFilter === "newest"}
                                  onChange={(e) =>
                                    setDateFilter(e.target.value)
                                  }
                                />{" "}
                                <span
                                  style={{
                                    fontWeight: "200",
                                    color: "GrayText",
                                    marginLeft: "29px",
                                    fontSize: "20px",
                                  }}
                                >
                                  Newest First
                                </span>
                              </Label>
                            </FormGroup>
                          </div>
                        </FormGroup>

                        <div className="d-flex justify-content-center mt-4 flex-column">
                          <Button
                            color="primary"
                            className="me-3 mt-2"
                            style={{
                              backgroundColor: "#022D88",
                              width: "100%",
                              padding: "8px 0",
                              borderColor: "#022D88",
                              borderRadius: "9px",
                            }}
                            onClick={() => {
                              filterReviewsByRatingAndDate();
                              setFilterModalOpen(false);
                            }}
                          >
                            Save
                          </Button>

                          <Button
                            className="mt-2"
                            outline
                            onClick={() => setFilterModalOpen(!filterModalOpen)}
                            style={{
                              width: "100%",
                              backgroundColor: "white",
                              color: "#022D88",
                              padding: "8px 0",
                              borderRadius: "9px",
                              borderColor: "#022D88",
                            }}
                          >
                            Close
                          </Button>
                        </div>
                      </Form>
                    </ModalBody>
                  </Modal>
                  <div>
                    {displayReviews.slice(0, visibleCount).map((review) => (
                      <ReviewCard key={review.Name} {...review} />
                    ))}

                    {visibleCount < displayReviews.length && (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <button
                          onClick={loadMoreReviews}
                          style={{
                            color: "blue",
                            fontSize: "1.4rem",
                            textDecoration: "underline",
                            background: "none",
                            border: "none",
                            padding: "8px 0",
                          }}
                        >
                          Load More
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </Container>
            </Container>

            {/* Sticky App Store Footer */}
            <div className="sticky-app-footer">
              <div
                style={{
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginRight: "10px",
                }}
              >
                Download Our App
              </div>
              <a
                href="https://play.google.com/store/apps/details?id=com.mycompany.tacos"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  textDecoration: "none",
                }}
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                />
              </a>
              <a
                href="https://apps.apple.com/us/app/wknd-app/id6736915994"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  textDecoration: "none",
                }}
              >
                <img
                  src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1288329600"
                  alt="Download on the App Store"
                />
              </a>
            </div>
          </div>
        ) : (
          <NotFound404 />
        )}
      </div>
    </div>
  );
}

// Component for Review Card
const ReviewCard = ({ Name, Review, created_at, Rating }) => {
  // Current date
  const now = new Date();

  // Truncate Name if longer than 7 characters
  const displayName =
    Name && Name.length > 7 ? `${Name.substring(0, 7)}...` : Name;
  // Convert the epoch timestamp to a Date object
  const createdDate = new Date(created_at);

  // Calculate the difference in milliseconds
  const timeDifference = now - createdDate;

  // Convert milliseconds to days
  const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  // Conditional formatting for "days ago"
  const formattedTimeAgo =
    daysAgo == 0
      ? "Today"
      : daysAgo === 1
      ? "1 day ago"
      : `${daysAgo} days ago`;

  return (
    <Row
      className="justify-content-center reiew-card-spaceing"
      style={{ margin: "20px auto", maxWidth: "900px" }}
    >
      <Col
        xs={12}
        className="card-shadow"
        style={{
          backgroundColor: "#DFDFED",
          border: "1px solid #0D1345",
          borderRadius: "22px",
          padding: "20px",
        }}
      >
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <h3 className="review-title" style={{ color: "#022D88" }}>
              {Review}
            </h3>
          </Col>
          <Col xs={7} sm={7} md={7} lg={8}>
            <div className="d-flex align-items-center">
              {[...Array(Rating)].map((_, index) => (
                <i
                  key={index}
                  className="bi bi-star-fill reviewstars"
                  style={{
                    color: "#022D88",
                    fontSize: "1.8rem",
                    paddingRight: "5px",
                  }}
                ></i>
              ))}
            </div>
          </Col>

          <Col xs={5} sm={5} md={5} lg={4} className="text-end">
            <h4 style={{ color: "#022D88" }} className="reviewer">
              {displayName}
            </h4>
            {/* Display the formatted time ago */}
            <h5 style={{ color: "#7C93C3" }}>{formattedTimeAgo}</h5>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default VendorProfile;
